import { ChangeBizsolStateToWaitingMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const changeBizsolStateToWaitingHandler =
  graphql.mutation<ChangeBizsolStateToWaitingMutation>(
    "changeBizsolStateToWaiting",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          changeBizsolStateToWaiting: {
            result: true,
          },
        },
      });
    }
  );
